var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('RouterView'),_c('ElDialog',{attrs:{"visible":_vm.previewImageVisible,"width":"60%"},on:{"update:visible":function($event){_vm.previewImageVisible=$event}}},[_c('img',{attrs:{"src":_vm.previewImageUrl}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }